define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"csi/xml",
	"csi/enums",
	"csi/xml/Query"
], function(declare,Widget,xml,enums,Query) {
	var SHARED_CREW_LEVEL = "SharedCrewLevel";
	var FOR_LEVEL = "ForLevel";

	return declare(Widget, {
		_createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			//Summary: first we check if nodeRoot type exists in SharedCrewLevel Enum. If it does, then we add a new <Attribute/>
			//with Id="ForLevel" Op="EQ", SValue="SharedCrewLevel:ROOT_NODE_TYPE" and Path="Child:__Parent__".
			var ql = this.inherited(arguments);
			if (ql.bMain) {
				var forLevelEnum = xml.enumCreate(SHARED_CREW_LEVEL, this.getViewNodeType());
				if (enums.getStore(SHARED_CREW_LEVEL).get(forLevelEnum)) {
					ql.serverQuery = new Query().Attr(FOR_LEVEL, xml.OP_EQUALS, forLevelEnum, xml.path(xml.ATTR_PARENT));
				}
			}
			return ql;
		}
	});
});